import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useEffectOnce } from '@chilecompra/react-kit'
import { Spinner } from '@chilecompra/react-kit/components'
import { onGetTokenThunk } from './AuthorizationProvider.actions'
import AuthorizationContext from './AuthorizationProvider.context'
import { Root } from './AuthorizationProvider.styles'

/**
 * The Authorization Provider container.
 */
const AuthorizationProvider = ({ children }) => {
  const dispatch = useDispatch()
  const {
    accessToken,
    authInfo: { loading: loadingAuthInfo, userType, orgCode },
    gettingToken
  } = useSelector(state => state.authorizationProvider)

  useEffectOnce(() => {
    if (accessToken === undefined) {
      dispatch(onGetTokenThunk())
    }
  })

  const isPrivated = useMemo(() => {
    return userType === '' ? undefined : userType === 'Comprador' || userType === 'Proveedor'
  }, [userType])

  if (!(accessToken && !gettingToken && userType && !loadingAuthInfo)) {
    return (
      <Root>
        <Spinner />
      </Root>
    )
  }

  return (
    <AuthorizationContext.Provider value={{ isPublic: !isPrivated, isPrivated, userType, orgCode }}>
      {children}
    </AuthorizationContext.Provider>
  )
}

AuthorizationProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default AuthorizationProvider
